import "../scss/front.scss";

import {
  putScrollbarSizeInCSSVariable,
  removeOnloadHiddenStatus,
} from "./common/functions";
import { couponsTable } from "./components/couponstable.js";
import { generalVision } from "./components/generalvision.js";
import { initMenu } from "./components/menu.js";
import { blockOdd } from "./components/odd.js";
import { blockTable } from "./components/table.js";

window.addEventListener("DOMContentLoaded", () => {
  putScrollbarSizeInCSSVariable();
  removeOnloadHiddenStatus();

  initMenu();
  couponsTable();
  generalVision();
  blockOdd();
  blockTable();
});
